import type { RouteRecordRaw } from 'vue-router';
import { isModuleRoutingEnabled, isModuleRouteEnabled, resolveModuleRoutePath } from '@/app-router/module-routing';
import type { GetModulePageComponent, ModuleRegistryEntry, ModuleRoutingContext } from '@/app-router/types';

export function buildModuleRoutes(
  settings: Record<string, unknown>,
  registry: readonly ModuleRegistryEntry[],
  getComponent: GetModulePageComponent,
  context: ModuleRoutingContext = {},
): RouteRecordRaw[] {
  const routes: RouteRecordRaw[] = [];

  for (const module of registry) {
    if (!isModuleRoutingEnabled(settings, module.id, context)) {
      continue;
    }

    for (const routeDef of module.routes) {
      if (!isModuleRouteEnabled(settings, module.id, routeDef, context)) continue;

      const component = getComponent(routeDef.component);

      if (!component) {
        console.warn(`[app-router] Unknown module component "${routeDef.component}" for route "${routeDef.name}"`);
        continue;
      }

      routes.push({
        path: resolveModuleRoutePath(settings, module.id, routeDef, context),
        name: routeDef.name,
        meta: {
          authenticate: true,
          moduleId: module.id,
        },
        component,
      });
    }
  }

  return routes;
}
